module.exports = __webpack_public_path__ + "assets_1773798366357/img/pic_6.13790e82.png";